import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { PINCODE_WEATHER_APIS } from "@/api_framework/api_config";
import { useQuickCommerce } from "@/app/hooks/useQuickCommerce";
import { IWeatherReason } from "./interface";

export const useWeatherReasons = (enabled: boolean) => {
  const quickCommerce = useQuickCommerce();
  const [reasons, setReasons] = useState<IWeatherReason[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const hasFetched = useRef<boolean>(false);

  const fetchReasons = useCallback(async () => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem(quickCommerce.localStorage.ACCESS_TOKEN.key);
      const res = await axios.get(PINCODE_WEATHER_APIS.WEATHER_REASONS, {
        headers: { Authorization: `${accessToken}`, "Content-Type": "application/json" },
      });
      if (res.data?.status) {
        setReasons(res.data.data ?? []);
      }
    } catch (e) {
      hasFetched.current = false;
    } finally {
      setIsLoading(false);
    }
  }, [quickCommerce]);

  useEffect(() => {
    if (enabled) fetchReasons();
  }, [enabled, fetchReasons]);

  return { reasons, isLoading };
};
